import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  BATTLESHOCK_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  DURING_SETUP,
  END_OF_COMBAT_PHASE,
  END_OF_TURN,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SHOOTING_PHASE,
  START_OF_BATTLESHOCK_PHASE,
  WARDS_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'

const Artifacts = {
 /* Mindblade: {
    effects: [
      {
        name: `Mindblade`,
        desc: `Pick 1 of the bearer's melee weapons. At the end of the combat phase, if any wounds or mortal wounds caused by attacks made with that weapon were allocated to an enemy HERO in that phase and that HERO was not slain, that HERO cannot carry out heroic actions for the rest of the battle.`,
        when: [END_OF_COMBAT_PHASE],
      },
    ],
  },
  'Bones of the Abyss': {
    effects: [
      {
        name: `Bones of the Abyss`,
        desc: `SOULMASON only. Each time the bearer successfully casts a spell that is not unbound, add 1 to the Attacks characteristic of the bearer' Ossified Claws until the end of that turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  Marrowpact: {
    effects: [
      {
        name: `Marrowpact`,
        desc: `Each time the bearer fights, after all of their attacks have been resolved, you can heal up to a number of wounds allocated to the bearer equal to the number of wounds and mortal wounds caused by those attacks that were allocated to enemy units.`,
        when: [WOUND_ALLOCATION_PHASE],
      },
    ],
  }, */
  'Shard of Necris': {
    effects: [
      {
        name: `Shard of Necris - Passive`,
        desc: `Effect: If the unmodified hit roll for an attack that targets this unit is 1-4 and this unit did not charge in the same turn, the attack fails and the attack sequence ends.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
    ],
  },
  "Blade of the Nadir": {
    effects: [
      {
        name: `Blade of the Nadir`,
        desc: `Effect: Pick 1 of this unit's non-Companion melee weapons. For the rest of the battle, each time you make an unmodified wound roll of 6 for a combat attack made with that weapon, inflict D3 mortal damage on the target of the attack after the Fight ability has been resolved.`,
        when: [DURING_SETUP],
      },
    ],
  },
  'Amulet of Gnosis': {
    effects: [
      {
        name: `Amulet of Gnosis - Passive`,
        desc: `Effect: No mortal damage is inflicted on friendly Ossiarch Bonereapers units by Retreat abilities while they are wholly within 12" of this unit.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'The Lance of Ossia (AoR)': {
    effects: [
      {
        name: `Helm of Tyranny (AoR) - Passive`,
        desc: `Effect: Subtract 3 from the control scores of enemy units while they are within 12" of this unit.`,
        when: [END_OF_TURN],
      },
    ],
  },
  'The Null Myriad (AoR)': {
    effects: [
      {
        name: `Gothizzar Cartouche (AoR)`,
        desc: `Declare: PIck a visible enemy unit within 12" of this unit to be the target.
        Effect: Roll a dice. On a 3+, add 1 to hit rolls for combat attacks made by friendly Null Myriad units that target that unit for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
 /* 'Gothizzar Cartouche': {
    effects: [
      {
        name: `Gothizzar Cartouche`,
        desc: `OSSIFECTOR only. Add 1 to wound rolls for attacks made with melee weapons by friendly OSSIARCH BONEREAPERS units wholly within 9" of the bearer.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  Luminscythe: {
    effects: [
      {
        name: `Luminscythe`,
        desc: `SOULREAPER only. Subtract 1 from hit rolls and wound rolls for attacks that target the bearer while they are within 3" of any enemy units.`,
        when: [COMBAT_PHASE, SHOOTING_PHASE],
      },
    ],
  }, */
} satisfies TItemDescriptions

export default tagAs(Artifacts, 'artifact')
